export default function(config, {product, quantity = 1}, analytics) {
    if (!product) {
        return
    }

    analytics.track('view_item', {
        currency: 'USD',
        value: product.price,
        items: [{
            item_id: product.id,
            item_name: product.title || product.name,
            item_category: product.type,
            price: product.price,
            quantity,
        }],
    })
}
